export default function CedarLogo({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Trunk */}
      <rect x="45" y="72" width="10" height="20" rx="2" fill="currentColor" opacity="0.8" />
      {/* Bottom layer - widest */}
      <polygon points="50,52 18,78 82,78" fill="currentColor" opacity="0.75" />
      {/* Middle layer */}
      <polygon points="50,34 22,60 78,60" fill="currentColor" opacity="0.85" />
      {/* Top layer */}
      <polygon points="50,16 28,44 72,44" fill="currentColor" opacity="0.9" />
      {/* Tip */}
      <polygon points="50,4 36,24 64,24" fill="currentColor" />
    </svg>
  );
}
